import { Link } from "components/base";
import { Flex } from "components/base/container";
import React from "react";
import styled from "styled-components";

export const GradientBorderBtn: React.FC<{ href?: string; children: React.ReactNode }> = ({ href, children }) => {
  return (
    <Link href={href} target={"_blank"} background={"linear-gradient(103.29deg, #E667B1 5.49%, #8767E6 100%)"} borderRadius={"6px"} p={"2px"}>
      <Flex bg={"normal"} borderRadius={"4px"} p={"8px 16px"}>
        <Flex
          background={"linear-gradient(103.29deg, #E667B1 5.49%, #8767E6 100%)"}
          fontWeight={"400"}
          fontSize={"18px"}
          lineHeight={"100%"}
          color={"transparent"}
          textTransform={"uppercase"}
          style={{ WebkitBackgroundClip: "text" }}
        >
          {children}
        </Flex>
      </Flex>
    </Link>
  );
};

export const NormalBtn = styled(Link)``;
NormalBtn.defaultProps = {
  background: "linear-gradient(103.29deg, #E667B1 5.49%, #8767E6 100%)",
  border: "1px solid #E667B1",
  p: "12px 24px",
  borderRadius: "6px",
  fontWeight: "400",
  fontSize: "18px",
  lineHeight: "100%",
  textTransform: "uppercase",
};
